package com.yet.tetris.domain.model.effects

enum class VisualTextKey {
    SINGLE,
    DOUBLE,
    TRIPLE,
    TETRIS,
    CLEAR,
}
